// Load moment.js
window.moment = require('moment-timezone');

// FIXME: this isn't working at the module level
// Datepicker
// require('./lib/bootstrap-datepicker');

// FIXME: this isn't working at the module level
// require('daterangepicker');

/**
 * Import the specified files
 *
 * @param {*} filesRequire
 */
function importFiles(filesRequire) {
    filesRequire.keys().forEach(filesRequire);
}

require('./ribit');

require('./lib/jquery.livewire');
require('./lib/jquery.sortable');

// FIXME: this isn't working for some reason
// require('./lib/query-builder.standalone');
importFiles(require.context('./admin/', true, /\.js$/i));
importFiles(require.context('./reporting/', true, /\.js$/i));
